var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.standAlone)?_c('router-view'):_c('layout',[_c('template',{slot:"layout-main"},[_c('router-view')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }